export default __webpack_public_path__ + "static/media/RobotoCondensed-Italic.7d709989.ttf";